// extracted by mini-css-extract-plugin
export var discard = "_3r-3";
export var muiTooltipTooltip = "_3r-5";
export var notificationBar = "_3r-2";
export var saveButtonHoverSlotWrapper = "_3r-4";
export var show = "_3r-1";
export var spacer = "_3r-0";